import { useEffect } from 'react';
import inputController, { InputLockReason } from '../../../services/InputController';

/**
 * SC-375: the gallery covers the map, so walking would be blind and could silently drop you out of the
 * conversation. Movement stays locked while it is on screen; picking another layout is how you walk again.
 * `galleryShown` is false while the gallery is chosen but hidden (reconnecting, loading), when the map
 * is visible again. Goes through InputController so leaving the gallery never re-enables movement that
 * chat, a modal or the whiteboard still holds locked.
 */
export function useGalleryMovementLock(galleryShown: boolean): void {
  useEffect(() => {
    if (!galleryShown) return;
    inputController.lockInput(InputLockReason.GALLERY_VIEW);
    return () => inputController.unlockInput(InputLockReason.GALLERY_VIEW);
  }, [galleryShown]);
}
